import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';

type MobileAssetTabContextType = {
	activeTab: 'info' | 'map';
	setActiveTab: (tab: 'info' | 'map') => void;
	showMapTab: boolean;
	setShowMapTab: (show: boolean) => void;
};

const MobileAssetTabContext = createContext<MobileAssetTabContextType>({
	activeTab: 'info',
	setActiveTab: () => {},
	showMapTab: false,
	setShowMapTab: () => {},
});

export function MobileAssetTabProvider({ children }: { children: ReactNode }) {
	const [activeTab, setActiveTab] = useState<'info' | 'map'>('info');
	const [showMapTab, setShowMapTab] = useState(false);
	return (
		<MobileAssetTabContext.Provider value={{ activeTab, setActiveTab, showMapTab, setShowMapTab }}>
			{children}
		</MobileAssetTabContext.Provider>
	);
}

export function useMobileAssetTab() {
	return useContext(MobileAssetTabContext);
}
